import { useState } from "react";
import AdminModal from "../../../core/admin/adminModal";
import { useAuth } from "../../../../context/authProvider";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../../../../firebase";
import { createDate } from "../../../../utils/functions";
import AdminButton from "../../../core/admin/adminButton";
import AdminField from "../../../core/admin/adminField";
import AdminTextInput from "../../../core/admin/adminTextInput";
import AdminCallout from "../../../core/admin/adminCallout";

export default function CreateAdModal({ close, finish }: { close: () => void, finish: () => void }) {

    const { userId } = useAuth();
    const [name, setName] = useState("");
    const [link, setLink] = useState("");
    const [until, setUntil] = useState("");
    const [loading, setLoading] = useState(false);
    const [errored, setErrored] = useState(false);

    const createAdDraft = async (e: React.FormEvent<HTMLFormElement>) => {
        try {
            e.preventDefault();
            setLoading(true);
            if (!userId) {
                throw new Error("Autenticação necessária");
            }

            const docRef = await addDoc(collection(db, "ads"), {
                name,
                link,
                until: createDate(until),
                draft: true,
                createdAt: serverTimestamp(),
                visible: false,
                order: 0
            })

            if (!docRef.id) {
                setLoading(false);
                setErrored(true);
                return null;
            }
            setErrored(false);
            setLoading(false);
            finish();
        } catch (error) {
            setLoading(false);
            setErrored(true);
            console.log(error);
        }
    }

    const handleUntil = (value: string) => {
        const barless = value.replace("/", "").replace("/", "");
        if ((!/^\d+$/.test(barless) && barless !== "") || barless.length > 8) {
            return null;
        }
        if(barless.length > 4){
            setUntil(`${barless.substring(0, 2)}/${barless.substring(2, 4)}/${barless.substring(4)}`)
            return null;
        }
        if(barless.length > 2){
            setUntil(`${barless.substring(0, 2)}/${barless.substring(2)}`)
            return null;
        }
        setUntil(barless);
    }

    return (
        <AdminModal
            close={close}
            title="Criar rascunho de anúncio"
            subtitle="Dados iniciais — as imagens são enviadas depois, nos detalhes do anúncio."
            footer={
                <>
                    <AdminButton variant="secondary" disabled={loading} onClick={close}>Cancelar</AdminButton>
                    <AdminButton type="submit" form="create-ad-form" loading={loading} className="sm:min-w-[120px]">Criar</AdminButton>
                </>
            }
        >
            <form id="create-ad-form" onSubmit={e => createAdDraft(e)} className="flex flex-col gap-4">
                <AdminField label="Nome" htmlFor="new-ad-name">
                    <AdminTextInput id="new-ad-name" value={name} onChange={e => setName(e.target.value)} placeholder="Nome do anunciante/campanha" />
                </AdminField>
                <AdminField label="Link" htmlFor="new-ad-link">
                    <AdminTextInput id="new-ad-link" inputMode="url" value={link} onChange={e => setLink(e.target.value)} placeholder="https://" />
                </AdminField>
                <AdminField label="Data final" htmlFor="new-ad-until" hint="A data deve estar no formato dd/mm/aaaa">
                    <AdminTextInput id="new-ad-until" inputMode="numeric" value={until} onChange={e => handleUntil(e.target.value)} placeholder="dd/mm/aaaa" />
                </AdminField>
            </form>
            {
                errored ?
                    <AdminCallout tone="danger" className="mt-4">Ocorreu um erro na operação</AdminCallout>
                    : null
            }

            {/* <AdImagesUploader/> */}
        </AdminModal>
    )
}
